import { Button, Modal } from 'reactstrap';
import {
  GuestPreBookingInvestor,
  GuestVisitInvestor,
} from '../../pages/investors/models/guestInvestorModel';
import { GuestPropertyInfoDetail } from '../../pages/guest/models/guestModel';
import { ActivateGuestVisits } from '../../models/landlordInvestorModel';

interface Props {
  guestId: string;
  guestPropertyId?: string;
  isOpen: boolean;
  onToggle: () => void;
  onConfirmation: (data: ActivateGuestVisits) => void;
  bodyText: string;
  confirmationText: string;
  abortText: string;
  investor:
    | GuestVisitInvestor
    | GuestPropertyInfoDetail
    | GuestPreBookingInvestor;
}

const ActivateEntityInvestorModal = ({
  guestId,
  guestPropertyId = '',
  isOpen,
  onToggle,
  onConfirmation,
  bodyText,
  confirmationText,
  abortText,
  investor,
}: Props) => {
  return (
    <Modal
      className="modal-dialog-centered"
      isOpen={isOpen}
      toggle={() => onToggle()}
    >
      <div className="modal-header">
        <h6 className="modal-title" id="modal-title-default">
          Confirmar acción
        </h6>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={() => onToggle()}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <div className="modal-body">
        <p>{bodyText}</p>
      </div>
      <div className="modal-footer">
        <Button
          color="primary"
          type="button"
          onClick={() =>
            onConfirmation({ guestId, guestPropertyId, investorInfo: investor })
          }
        >
          {confirmationText}
        </Button>
        <Button
          className="ml-auto"
          color="link"
          data-dismiss="modal"
          type="button"
          onClick={() => onToggle()}
        >
          {abortText}
        </Button>
      </div>
    </Modal>
  );
};

export default ActivateEntityInvestorModal;
